module.exports = __webpack_public_path__ + "img/svg/step3.b3c98df11d6b7cfa72845bbdda8e30ce.svg";